import React, {useState} from 'react';
import {Dropdown, Space} from 'antd';
import PropTypes from 'prop-types';
import './AddButton.css';
import {StyledAddButton} from './StyledAddButton';
import {ChevronDownIcon} from '../../../../icons';

const AddButton = ({
  children,
  disabled = false,
  menuItems,
  onClick,
  total,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuProps = {
    items: menuItems,
    onClick: (e) => onClick && onClick(e),
  };

  const onOpenChange = (open) => setIsOpen(open);

  return (
    <Dropdown
      classNames={{root: 'add-button-overlay'}}
      disabled={disabled}
      menu={menuProps}
      trigger='click'
      onOpenChange={onOpenChange}
    >
      <StyledAddButton
        {...rest}
        disabled={disabled}
        open={isOpen}
      >
        <Space>
          {children}
          <ChevronDownIcon />
        </Space>
      </StyledAddButton>
    </Dropdown>
  )
}

AddButton.propTypes = {
  disabled: PropTypes.bool,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  onClick: PropTypes.func
}

export default AddButton;
